import clsx from 'clsx';
import React from 'react';
import { factory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './NotificationDot.module.css.mjs';
import { getPositionVariables } from './NotificationDot.utils.mjs';

const NotificationDot = factory((props, ref) => {
  const { children, disabled = false, position = "top-end", inline = false, offset = 0, withBorder = true, className, ...rest } = props;
  const classNames = clsx("kohler-notification-dot-root", classes.notificationDot, className);
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: clsx("kohler-notification-dot-wrapper", classes.notificationDotWrapper),
      style: { ...getPositionVariables(position, offset) },
      "data-inline": inline ? "true" : void 0
    },
    !disabled && /* @__PURE__ */ React.createElement(Box, { ref, className: classNames, "data-with-border": withBorder ? "true" : void 0, ...rest }),
    children
  );
});

export { NotificationDot };
